import React from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

const notPublishedStyle = { backgroundColor: 'yellow', opacity: '0.5' }

export default function CompanyRow(props) {
  const style = props.company.isPublished ? {} : notPublishedStyle
  return (
    <TableRow key={props.company._id} style={notPublishedStyle}>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.company.officialName}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.company.industry ? props.company.industry.name : '-'}<br/>
        <span style={{fontSize:"10px", color:"grey"}}>{props.company.mainCategory ? props.company.mainCategory.name : ''}</span>
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal', width:'150px'}}>
        {props.company.city ? props.company.city.name : ''}<br/>
        {props.company.municipality}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.company.phoneNumber}<br/>
        {props.company.emailAddress}
      </TableRowColumn>
    </TableRow>
  );
}



// WEBPACK FOOTER //
// ./src/components/FrontPage/CompanyRow.js